export default "__VITE_ASSET__Dd2MITFj__"